export default "__VITE_ASSET__ef11d769__"